import { Box } from '@mui/material';
import React from 'react';
import styles from './page-header.module.scss';

export default function PageHeader(props: any) {
    const className = [styles.pageHeader, props.className].filter(Boolean).join(' ');

    return (<Box className={className}>
        <div className={styles.pageHeaderContainer}> 
            {props.children}
        </div>
    </Box>)
}
